import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IActions } from './CustomerPricingLookup.actions';
import reducer, { initialState, IState } from './CustomerPricingLookup.reducer';

export const CustomerPricingLookupStateContext = createContext<IState>(initialState);
export const CustomerPricingLookupDispatchContext = createContext<Dispatch<IActions>>(() => null);

export const useCPLDispatch = () => useContext(CustomerPricingLookupDispatchContext);
export const useCPLState = () => useContext(CustomerPricingLookupStateContext);
export const useCPLContextSelector = <K extends keyof IState>(selector: (state: IState) => IState[K]) => useContextSelector<IState, IState[K]>(CustomerPricingLookupStateContext, selector);

interface ICustomerPricingLookupStateProvider {
  children: React.ReactNode;
}

const CustomerPricingLookupStateProvider = ({ children }: ICustomerPricingLookupStateProvider) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <CustomerPricingLookupStateContext.Provider value={state}>
      <CustomerPricingLookupDispatchContext.Provider value={dispatch}>
        {children}
      </CustomerPricingLookupDispatchContext.Provider>
    </CustomerPricingLookupStateContext.Provider>
  );
};

export default CustomerPricingLookupStateProvider;
